var map = {
	"./acrylic-print.svg": 50945,
	"./aluminum-print.svg": 810770,
	"./art-print.svg": 987915,
	"./art-product.svg": 761907,
	"./athletic-crop-top.svg": 893167,
	"./baby-leggings.svg": 845631,
	"./beanie.svg": 235726,
	"./bed-pillow-sham.svg": 909271,
	"./bed-pillow-sleeve.svg": 233540,
	"./big-square-scarf.svg": 914196,
	"./blanket.svg": 259459,
	"./bodycon-dress.svg": 480704,
	"./boxer-briefs.svg": 623022,
	"./boyshorts.svg": 636401,
	"./canvas.svg": 968350,
	"./capris.svg": 268384,
	"./cheeky-briefs.svg": 979741,
	"./classic-crewneck.svg": 45581,
	"./classic-pullover-hoodie.svg": 762401,
	"./coaster.svg": 862049,
	"./comfort-long-sleeve-t-shirt.svg": 969574,
	"./comfort-racerback-tank-top.svg": 44202,
	"./comfort-slimfit-t-shirt.svg": 19637,
	"./comfort-t-shirt.svg": 301466,
	"./crewneck-sweatshirt.svg": 319481,
	"./cropped-pullover-hoodie.svg": 770936,
	"./dad-cap-with-printed-patch.svg": 577955,
	"./dad-cap.svg": 948974,
	"./day-tote.svg": 492571,
	"./desk-mat.svg": 916556,
	"./draped-kimono.svg": 146012,
	"./drawstring-bag.svg": 819886,
	"./duvet-cover.svg": 598750,
	"./fabric.svg": 13681,
	"./face-mask.svg": 208246,
	"./fitted-polo-shirt.svg": 971228,
	"./fitted-skirt.svg": 322744,
	"./fitted-tank-top.svg": 158189,
	"./flare-dress.svg": 280396,
	"./flare-skirt.svg": 536556,
	"./flow-pullover-hoodie.svg": 351849,
	"./flow-racerback-tank-top.svg": 853790,
	"./galaxy-s3.svg": 386997,
	"./galaxy-s4.svg": 393498,
	"./galaxy-s5.svg": 577271,
	"./galaxy-s6-edge.svg": 340034,
	"./galaxy-s6.svg": 90268,
	"./galaxy-s7-edge.svg": 753865,
	"./galaxy-s7.svg": 799809,
	"./galaxy-s8.svg": 87174,
	"./galaxy-s9.svg": 329171,
	"./headband.svg": 938513,
	"./holiday-stocking.svg": 357241,
	"./ipad-mini.svg": 856598,
	"./iphone4.svg": 501411,
	"./iphone5.svg": 757782,
	"./iphone6.svg": 486669,
	"./iphone6plus.svg": 821725,
	"./iphone7.svg": 836296,
	"./iphone7plus.svg": 451412,
	"./iphonex.svg": 116231,
	"./iphonexr.svg": 545367,
	"./iphonexsmax.svg": 216820,
	"./kangaroo-hoodie.svg": 585693,
	"./kimono-robe.svg": 573454,
	"./leggings.svg": 164758,
	"./lightweight-face-covering.svg": 149802,
	"./lightweight-face-covering@2x.svg": 854200,
	"./long-scarf.svg": 294544,
	"./loose-tank-top.svg": 756299,
	"./lounge-pants.svg": 812225,
	"./makeup-bag.svg": 552530,
	"./market-tote.svg": 267821,
	"./mini-shorts.svg": 831313,
	"./notebook.svg": 998457,
	"./origami-tote.svg": 375099,
	"./peignoir.svg": 656971,
	"./pencil-case.svg": 153126,
	"./permanent-sticker.svg": 409154,
	"./pet-bowl.svg": 162566,
	"./pillow-case.svg": 517362,
	"./placemat.svg": 898827,
	"./poster.svg": 793581,
	"./premium-crewneck.svg": 89784,
	"./premium-drawstring-bag.svg": 134058,
	"./premium-long-sleeve-t-shirt.svg": 768149,
	"./premium-pullover-hoodie.svg": 60918,
	"./premium-t-shirt.svg": 482169,
	"./premium-unisex-tank-top.svg": 694079,
	"./premium-zipper-hoodie.svg": 726017,
	"./racerback-tank-top.svg": 880403,
	"./scarf.svg": 554841,
	"./scoop-bralette.svg": 146046,
	"./shirt-bellacanvas-3001.svg": 360206,
	"./shirt-bellacanvas-6004.svg": 900420,
	"./shirt-milltex-901.svg": 160711,
	"./shorts.svg": 332391,
	"./snapback.svg": 29979,
	"./spiral-notebook.svg": 628645,
	"./square-scarf.svg": 513143,
	"./stainless-steel-tumbler.svg": 558278,
	"./stainless-steel-water-bottle.svg": 122323,
	"./stationery-card.svg": 73319,
	"./tablecloth.svg": 86058,
	"./tea-towel.svg": 17758,
	"./tote-bag.svg": 754253,
	"./twilly-scarf.svg": 451803,
	"./unisex-joggers.svg": 368050,
	"./unisex-polo-shirt.svg": 546374,
	"./vegan-leather-backpack.svg": 794896,
	"./vegan-leather-crossbody-purse.svg": 91332,
	"./vegan-leather-makeup-bag.svg": 740222,
	"./vegan-leather-placemat.svg": 134079,
	"./vegan-leather-tote-bag.svg": 58545,
	"./wall-tapestry.svg": 754361,
	"./wood-print.svg": 818507,
	"./wrap-skirt.svg": 137084,
	"./yoga-capris.svg": 383013,
	"./yoga-leggings.svg": 59203,
	"./yoga-shorts.svg": 104390,
	"./youth-leggings.svg": 850068,
	"./zipper-carry-all.svg": 232844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 424322;